import styled from 'styled-components';

export const AutoCompleteItemWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  &>:nth-child(2) {
    font-weight: bold;
  }
`;
